import { AuthService } from './../../shared/models/auth.service';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { VehicleAttributeModel } from './vehicleattribute.model';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';

@Injectable()
export class VehicleAttributeService {
  constructor(private authService: AuthService, private http: Http) { }


  public GetVehicleAttributeList(input?: DataListModel): Observable<IAPIResponse> {
    let getVehicleAttributeUrl = WeGoConfig.API_GET_VEHICLEATTRIBUTE_DETAIL;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getVehicleAttributeUrl = getVehicleAttributeUrl + "?" + queryString;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getVehicleAttributeUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportVehicleAttributeList(input?: DataListModel): any {
    input.currentPage = 0;
    let queryString = this.authService.HandleAPIListInput(input);
    let getAttributeListUrl = WeGoConfig.API_EXPORT_VEHICLEATTRIBUTE_LIST + "?" + queryString;
    let headers = this.authService.GetHeader('text/csv');
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getAttributeListUrl, options);
  }

  public GetVehicleAttributeByHashId(vehicleAttributeHashId: string): Observable<IAPIResponse> {
    let getvehicleAttributeUrl = WeGoConfig.API_GET_VEHICLEATTRIBUTE_BY_HASH + "?vehicleAttributeHashId=" + vehicleAttributeHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getvehicleAttributeUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public AddNewVehicleAttribute(vehicleAttributeModel: VehicleAttributeModel): Observable<IAPIResponse> {
    let body = vehicleAttributeModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http.post(WeGoConfig.API_POST_VEHICLEATTRIBUTE_DETAIL, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
  public GetVehicleAttributeForCompany(ownerCompanyHashID: string): Observable<IAPIResponse> {
    let getvehicleAttributeUrl = WeGoConfig.API_GET_VEHICLEATTRIBUTE_BY_COMPANY + "?ownerCompanyHashID=" + ownerCompanyHashID;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getvehicleAttributeUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/vehicle-attribute/models/vehicleattribute.service.ts